import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";
import { authService } from "Service/Axios";
import { UserHover, ButtonLoader } from "Components";
import { FORM_BUILDER_FORM_UPDATE_COLLABORATOR_URL } from "Constant/api";
import { useFormCollaboratorList } from "Constant/apiHooks";
import { getFirstLetterOfName } from "Utils";

export const AddCollaborator = ({
  show,
  selectedForm,
  toggle,
  fetchFolderList,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const {
    formCollaboratorList,
    setFormCollaboratorList,
    loading: formCollaboratorLoading,
  } = useFormCollaboratorList(selectedForm?.formId);

  const handleChange = (e, index) => {
    const newArr = [...formCollaboratorList];
    newArr[index].check = e.target.checked;
    const modifiedArr = newArr.map((c) => ({
      ...c,
      formId: selectedForm?.formId,
    }));
    setFormCollaboratorList(modifiedArr);
  };

  const onUpdateCollaborator = async () => {
    setLoading(true);
    try {
      await authService(
        FORM_BUILDER_FORM_UPDATE_COLLABORATOR_URL,
        "POST",
        formCollaboratorList
      );
      setLoading(false);
      fetchFolderList();
      toast.success(t("common.messages.notification.success.updateForm"));
      toggle();
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };
  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("auth.formBuilder.updateCollaborator")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <div className="assignee-list ">
          <ul className="m-0 p-0">
            <li>
              <div className="search-div mb-2">
                <div className="input-group">
                  <button className="input-group-text" type="button">
                    <i className="pluto-search"></i>
                  </button>
                  <div className="form-floating">
                    <input
                      type="search"
                      className="form-control"
                      placeholder={t("common.placeHolder.searchAssignee")}
                      id="searchInput"
                    />
                    <label htmlFor="searchInput">
                      {t("common.label.assignee")}
                    </label>
                  </div>
                </div>
              </div>
            </li>
            <li className="assignee-list-date">
              <ul>
                {formCollaboratorLoading ? (
                  <li>
                    <div>CollaboratorLoading</div>
                  </li>
                ) : (
                  formCollaboratorList &&
                  formCollaboratorList.length > 0 &&
                  formCollaboratorList.map((collaborator, index) => (
                    <li className="assignee-item" key={index.toString()}>
                      <div className="form-check form-check-flex align-items-center">
                        <div className="cursor-pointer">
                          {/* <div className="assignee-user">
                            {collaborator.photoURL ? (
                              <img
                                src={collaborator.photoURL}
                                alt={`${collaborator.firstName}${collaborator.lastName}`}
                              />
                            ) : (
                              getFirstLetterOfName(collaborator)
                            )}
                          </div>
                          <div className="assignee-name">
                            <p>
                              {collaborator.firstName} {collaborator.lastName}
                            </p>
                          </div> */}
                          {/* <UserHover user={collaborator} /> */}
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Popover className="max-w-unset">
                                <UserHover user={collaborator} />
                              </Popover>
                            }
                          >
                            <div className="d-flex align-items-center">
                              <div className="w-6 h-6 rounded-circle overflow-hidden">
                                {collaborator.photoURL ? (
                                  <div className="img-box w-100 h-100 text-slate-500">
                                    <img
                                      src={collaborator.photoURL}
                                      alt={`${collaborator.firstName} ${collaborator.lastName}`}
                                      className="w-100 h-100 object-fit-cover"
                                    />
                                  </div>
                                ) : (
                                  getFirstLetterOfName(collaborator)
                                )}
                              </div>

                              <div className="avatar-short-dtls ms-2">
                                <span className="mb-0 text-xxs font-medium text-nowrap text-slate-500">
                                  {collaborator.firstName}{" "}
                                  {collaborator.lastName}
                                </span>
                              </div>
                            </div>
                          </OverlayTrigger>
                        </div>
                        <input
                          className="form-check-input ms-auto text-sm"
                          type="checkbox"
                          checked={collaborator.check}
                          onChange={(e) => handleChange(e, index)}
                        />
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="outline-primary" onClick={toggle} className="">
          {t("common.button.cancel")}
        </Button>
        {!loading ? (
          <Button variant="primary" onClick={onUpdateCollaborator}>
            {t("common.button.update")}
          </Button>
        ) : (
          <ButtonLoader />
        )}
      </Modal.Footer>
    </Modal>
  );
};
